import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GENERATE_INVOICE_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/generate_invoice`, {
        method: 'post',
        body: data
    })
        .then(response => {
            let contentType = response.headers.get('content-type');

            if (contentType === 'application/pdf') {
                return response.blob();
            }
            else {
                return response.json();
            }
        }).catch(error => console.log(error))
};

function* workerGenerateInvoice(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('invoice', args.data.invoice);
        formData.append('date', args.data.date);
        formData.append('period', args.data.period);
        formData.append('subject', args.data.subject);
        formData.append('counterparty', args.data.counterparty);
        formData.append('sum', args.data.sum);
        formData.append('type', args.data.type);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
        else {
            if (args.data.type === 'download') {
                const url = window.URL.createObjectURL(response);
                window.open(url, '_blank');
                const a = document.createElement('a');
                a.href = url;
                a.download = `Счёт ${ args.data.invoice } ${ args.data.app_name } от ${ new Date(args.data.date).toLocaleDateString('ru-Ru') }.pdf`;
                a.target = '_blank';
                a.click();

                // window.URL.revokeObjectURL(url);
                setTimeout(() => URL.revokeObjectURL(url), 1000);
            }
            else if (args.data.type === 'email') {
                growl({ type: 'success', message: response.message });
            }
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGenerateInvoice() {
    yield takeLatest(GENERATE_INVOICE_SAGA, workerGenerateInvoice);
}